/**
 * Token-forwarding helper.
 *
 * The /editor route's API endpoints (`/api/jobs/{id}/download`,
 * `/api/editor-ir/{id}`, `/api/editor-edit/{id}`) gate on
 * `_check_job_ownership` (web/server.py:850-865) which accepts a session
 * cookie OR an `?token=` query param OR an `Authorization: Bearer` header. In a // noqa: x-admin-token-banned — archival mention removed; new comment names Bearer
 * real-browser session the cookie does the work; in the editor smoke gate
 * (and any admin "open this user's job" workflow) we lean on `?token=`.
 *
 * This helper appends `?token=` from `window.location.search` to a URL
 * when the editor was opened with `?token=`. Harmless for users without
 * a token in their URL.
 */
export function appendTokenIfPresent(url) {
    if (typeof window === "undefined" || !window.location?.search) {
        return url;
    }
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (!token)
        return url;
    return url + (url.includes("?") ? "&" : "?") + "token=" + encodeURIComponent(token);
}
